var map = {
	"./Dots.svg": 97838,
	"./Illustration-Error.svg": 1585,
	"./MicPermissionsDialogImage.svg": 63040,
	"./PlayIcon.svg": 71451,
	"./addhero.16.svg": 30898,
	"./fonts/Bahnschrift.woff": 71491,
	"./icon-16.png": 19032,
	"./icon-32.png": 62854,
	"./icon-80.png": 82081,
	"./logo-filled.png": 45475,
	"./ping_image.png": 48815,
	"./transcription_signal_indicator.png": 76860
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34215;